import React, { useState } from 'react';
import './ChangePinModal.css';

const ChangePinModal = ({ isOpen, onClose, userId, token }) => {
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validate PINs match
    if (newPin !== confirmPin) {
      setError('PINs do not match');
      setLoading(false);
      return;
    }

    // Validate PIN length/format if needed
    if (newPin.length < 4) {
      setError('PIN must be at least 4 characters');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod/auth/change-pin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ userId, newPin })
      });

      if (response.ok) {
        // PIN changed successfully, redirect to week picks
        window.location.href = "/weekpicks";
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to change PIN');
      }
    } catch (err) {
      setError(err.message || 'Failed to change PIN. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Change PIN</h3>
        <h4>{userId}</h4>
        <p>You must change your PIN before continuing.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New PIN:</label>
            <input
              type="password"
              value={newPin}
              onChange={(e) => setNewPin(e.target.value)}
              placeholder="Enter new PIN"
              required
              minLength={4}
            />
          </div>

          <div className="form-group">
            <label>Confirm PIN:</label>
            <input
              type="password"
              value={confirmPin}
              onChange={(e) => setConfirmPin(e.target.value)}
              placeholder="Confirm new PIN"
              required
              minLength={4}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div className="modal-buttons">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? 'Changing PIN...' : 'Change PIN'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePinModal;

